import moment from "moment";
import { BudgetModel } from "./budget.model";
import { ProposalModel } from "./proposal.model";

export class PaymentModel {
  public id: number;

  public phase: number;
  public percentage: number;
  public totalGross: number;
  public totalDiscount: number;
  public totalVat: number;
  public totalWVat: number;

  public budgetId: number | null;
  public proposalId: number | null;

  public budget: BudgetModel | null;
  public proposal: ProposalModel | null;

  public createdAt: Date;
  public updatedAt: Date;

  constructor($obj?: any) {
    this.id = $obj && $obj.id ? $obj.id : '#new' + moment().valueOf();

    this.phase = $obj && $obj.phase ? $obj.phase : 0;
    this.percentage = $obj && $obj.percentage ? $obj.percentage : 0;
    this.totalGross = $obj && $obj.totalGross ? $obj.totalGross : 0.00;
    this.totalDiscount = $obj && $obj.totalDiscount ? $obj.totalDiscount : 0.00;
    this.totalVat = $obj && $obj.totalVat ? $obj.totalVat : 0.00;
    this.totalWVat = $obj && $obj.totalWVat ? $obj.totalWVat : 0.00;

    this.budgetId = $obj && $obj.budgetId ? $obj.budgetId : $obj && $obj.budget ? $obj.budget.id : null;
    this.proposalId = $obj && $obj.proposalId ? $obj.proposalId : $obj && $obj.proposal ? $obj.proposal.id : null;

    this.budget = $obj && $obj.budget? new BudgetModel($obj.budget) : null;
    this.proposal = $obj && $obj.proposal ? new ProposalModel($obj.proposal) : null;

    this.createdAt = $obj && $obj.createdAt ? new Date($obj.createdAt) : new Date();
    this.updatedAt = $obj && $obj.updatedAt ? new Date($obj.updatedAt) : new Date();
  }

  toAPI() {
    return {
      phase: this.phase,
      percentage: this.percentage,
      totalGross: this.totalGross,
      totalDiscount: this.totalDiscount,
      totalVat: this.totalVat,
      totalWVat: this.totalWVat,
      budgetId: this.budgetId,
      proposalId: this.proposalId,
    };
  }

  setByBudgetForm(form: any) {
    this.id = form.id;
    this.phase = form.phase;
    this.percentage = form.percentage;
    this.totalGross = form.totalGross;
    this.totalDiscount = form.totalDiscount;
    this.totalVat = form.totalVat;
    this.totalWVat = form.totalWVat;

    return this;
  }

  toBudgetAPI(create: boolean) {
    if (create) {
      return {
        phase: this.phase,
        percentage: this.percentage,
        totalGross: this.totalGross,
        totalDiscount: this.totalDiscount,
        totalVat: this.totalVat,
        totalWVat: this.totalWVat
      };
    } else {
      return {
        id: this.id,
        phase: this.phase,
        percentage: this.percentage,
        totalGross: this.totalGross,
        totalDiscount: this.totalDiscount,
        totalVat: this.totalVat,
        totalWVat: this.totalWVat
      };
    }
  }
}
